import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-filter-chip-range-date',
  templateUrl: './search-filter-chip-range-date.component.html',
  styleUrl: './search-filter-chip-range-date.component.scss',
})
export class SearchFilterChipRangeDateComponent {
  @Input() name!: string;
  @Input() startRange!: string;
  @Output() emitFilter = new EventEmitter<any>();

  range: { start: Date | null; end: Date | null } = { start: null, end: null };
  selectingStartDate = true;

  dateSelected(date: Date): void {
    if (this.selectingStartDate) {
      this.range.start = date;
      this.range.end = null;
    } else {
      this.range.end = new Date(date.setHours(23, 59, 59, 59));
      if (
        this.range.start &&
        this.range.end &&
        this.range.start > this.range.end
      ) {
        const temp = this.range.start;
        this.range.start = this.range.end;
        this.range.end = temp;
      }
    }

    this.selectingStartDate = !this.selectingStartDate;

    if (this.selectingStartDate) {
      this.emitFilter.emit(
        `${new Date(this.range.start!).toISOString()},${new Date(this.range.end?.setHours(23, 59, 59, 59)!).toISOString()}`
      );
    }
  }
  ngOnInit(): void {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Se `startDate` ou `endDate` não forem passadas, usa os valores padrão
    if (this.startRange) {
      this.range.start = new Date(this.startRange.split(',')[0]);
      this.range.end = new Date(new Date(this.startRange.split(',')[1]).setHours(23, 59, 59, 59));
      this.emitFilter.emit(
        `${new Date(this.range.start!).toISOString()},${new Date(this.range.end!).toISOString()}`
      );
    }

  }
  clearSelectedRange(): void {
    this.range = { start: null, end: null };
    this.selectingStartDate = true;
    this.emitFilter.emit(null);
  }
}
